module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAAfElEQVRIie2VMQ6AMAwDnVCY+P/T+AADf6CiAbfQhQmRMZZsRR2u6VLLsh6m2OGlgglyZTIoaHGAWrXWOXHbAfk+/iu5s0Cl3+Uh6y9XJ+JLAQ5wgAMc4G/g9sV7FFPjPJWRWH5eaEJ7mTJoDwla31XwrNs1ZBcwZRjBvU9NYB7hQLIBGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchbtb1-8.png
// module id = 418
// module chunks = 0